/**
 * Joins the optional title into the message body — both the transfer and its personalization carry a
 * single `message` field, so the builder's separate Title / Message inputs are folded into one string
 * with a blank line between them. Empty parts are dropped so a title-only or message-only transfer
 * stays clean. Pure logic, extracted from the CreateFlow view (epic #26) so it stays unit-testable.
 *
 * `download/transferMessage.splitTransferMessage` is the inverse and its test replays this function's
 * own output, which is what keeps the two halves of the fold from drifting apart.
 *
 * The inputs moved from the transfer options sheet into the personalization builder in ui#1814, and
 * the folded result now travels on BOTH `PersonalizationDraft.message` — what the branded download
 * page renders — and the transfer's own `message`, which is what the delivery email carries. One piece
 * of sender state, two carriers that need it, and never two places to edit it.
 */
export function composeMessage(title: string, message: string): string {
	return [title.trim(), message.trim()].filter(Boolean).join("\n\n");
}
